export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4026b149804759b3f511ddce477291046a74070abe&name=revalidateCommunity!'